import { render, staticRenderFns } from "./InvoicesConfirmModal.vue?vue&type=template&id=fb6c564c&"
import script from "./InvoicesConfirmModal.vue?vue&type=script&lang=js&"
export * from "./InvoicesConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports